import { NgModule } from '@angular/core';
import {Routes, RouterModule } from '@angular/router';

import {HeatMapComponent} from './components/heat-map/heat-map.component';

const routes: Routes = [
    {path: '', redirectTo: '/heatmap', pathMatch: 'full'},    
    {path:'heatmap', component:HeatMapComponent},  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// C:/Users/jvutukur/Downloads/HeatMap/ng-heatmap/ng-heatmap/src/app/app-routing.module.ts